<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>flight_takeoff</md-icon>
      </div>
      <h4 class="title">
        Departure Info
      </h4>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <span class="md-caption text-warning"> This is {{ tourType }} </span>
          <h6>Travel Dates</h6>
        </div>
        <div class="md-layout-item md-size-50">
          <md-datepicker
            v-if="$allowed('departure.manage')"
            v-model="departure.start_date"
            md-immediately
            :md-model-type="String"
          >
            <label>Departure Date</label>
          </md-datepicker>
          <md-field v-else class="md-form-group" slot="inputs">
            <md-icon class="text-primary hi-price-icon">event</md-icon>
            <label>Departure Date</label>
            <md-input
              :readonly="!$allowed('departure.manage')"
              v-model="departure.start_date"
              type="text"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-datepicker
            v-if="$allowed('departure.manage')"
            v-model="departure.end_date"
            md-immediately
            :md-model-type="String"
          >
            <label>Return Date</label>
          </md-datepicker>
          <md-field v-else class="md-form-group" slot="inputs">
            <md-icon class="text-primary hi-price-icon">event</md-icon>
            <label>Return Date</label>
            <md-input
              :readonly="!$allowed('departure.manage')"
              v-model="departure.end_date"
              type="text"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div v-if="$allowed('departure.manage')" class="md-layout">
        <div class="md-layout-item md-size-50">
          <h6>Prices</h6>
        </div>
        <div class="md-layout-item md-size-50 text-right">
          <md-switch v-model="departure.price_sync"
            >Synced with Adventure</md-switch
          >
        </div>
        <div class="md-layout-item md-size-33 price-row">
          <md-field class="md-form-group" slot="inputs">
            <md-icon
              ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
            ></md-icon>
            <label>GBP</label>
            <md-input
              :disabled="departure.price_sync"
              v-model="departure.prices.gbp"
              type="text"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33 price-row">
          <md-field class="md-form-group" slot="inputs">
            <md-icon
              ><i class="fas fa-euro-sign text-primary hi-price-icon"></i
            ></md-icon>
            <label>EUR</label>
            <md-input
              :disabled="departure.price_sync"
              v-model="departure.prices.eur"
              type="text"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33 price-row">
          <md-field class="md-form-group" slot="inputs">
            <md-icon
              ><i class="fas fa-dollar-sign text-primary hi-price-icon"></i
            ></md-icon>
            <label>USD</label>
            <md-input
              :disabled="departure.price_sync"
              v-model="departure.prices.usd"
              type="text"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h6>Group Size</h6>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <md-icon
              ><i class="fas fa-user-minus text-primary hi-price-icon"></i
            ></md-icon>
            <label>Min Group Size</label>
            <md-input
              :readonly="!canEdit"
              type="number"
              name="min_passengers"
              v-model="departure.min_group_size"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <md-icon
              ><i class="fas fa-user-plus text-primary hi-price-icon"></i
            ></md-icon>
            <label>Max Group Size</label>
            <md-input
              :readonly="!canEdit"
              type="number"
              name="max_passengers"
              v-model="departure.max_group_size"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <md-switch v-model="departure.public" :disabled="!canEdit"
            >Public</md-switch
          >
        </div>

        <div class="md-layout-item md-size-100">
          <div class="md-caption">Created On</div>
          <div class="">{{ departure.created_at | formatDate }}</div>
        </div>

        <div v-if="canEdit" class="md-layout-item md-size-100">
          <md-button
            class="md-raised md-dense md-success mt-4"
            @click.prevent="updateDeparture"
            >Update</md-button
          >
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import tourApi from "@/services/api/tour";
import { objectIncludes } from "@tiptap/vue-2";

export default {
  props: {
    tour: [String, Number],
    departure: {
      type: Object,
      tour: {
        type: Object,
        supplier: {
          type: Object,
          id: null
        }
      }
    }
  },
  data() {
    return {};
  },

  computed: {
    canEdit() {
      return (
        this.$allowed(["departure.manage", "departure.update"]) ||
        (this.isSupplier && this.$allowed(["departure.update.own"]))
      );
    },
    isSupplier() {
      return (
        this.departure?.tour?.supplier.id ==
        this.$store.state.auth.user.supplier.id
      );
    },
    tourType() {
      return this.departure.tour?.type?.value == "tour" ? "a Tour" : "an Event";
    }
  },
  methods: {
    updateDeparture() {
      tourApi
        .updateDeparture(this.tour, this.departure)
        // .updateDeparture(this.departure.tour.id, this.departure)
        .then(response => {
          this.$notify({
            timeout: 2500,
            message: "The Departure has been updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
          this.$emit("departureUpdated", response.data);
        })
        .catch(error => {});
    }
  }
};
</script>
